routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider']

export default function routes ($stateProvider, $urlRouterProvider, $locationProvider) {
  $locationProvider.html5Mode(true)

  $stateProvider
    .state('portfolio', {
      abstract: false,
      url: '/app/portfolio',
      views: {
        '': {
          template: require('../../../layout/layout.html')
        },
        'content': {
          template: require('../../../layout/contentNoBreadcrumb.html')
        },
        'aside': {
          template: require('../../../layout/aside.html'),
          controller: 'AsideCtrl'
        },
        'header': {
          template: require('../../../layout/header.html'),
          controller: 'HeaderCtrl'
        },
          'chatbox': {
            template: require('../chatbox/chatbox.html'),
            controller: 'ChatboxController',
            controllerAs: 'chatbox'
        },
        'footer': {
          template: require('../../../layout/footer.html')
        }
      }
    })  
    .state('portfolio.myPortfolio', {
      abstract: false,
      url: '/myPortfolio',
      template: require('./myPortfolio/myPortfolio.html'),
      controller: 'MyPortfolioCtrl',
      controllerAs: 'portfolioVm'  ,
      params: {
        haveGuest      : false,
        isOnEvaluation : false,
        isExternal     : false
      }    
    })  
    .state('portfolio.sharedPortfolio', {
      abstract: false,
      url: '/sharedPortfolio',
      template: require('./sharedPortfolio/sharedPortfolio.html'),
      controller: 'SharedPortfolioCtrl',
      controllerAs: 'sharedPortfolioVm'      
    })  
    .state('portfolio.otherPortfolio', {
      abstract: false,
      url: '/otherPortfolio',
      template: require('./otherPortfolio/otherPortfolio.html'),
      controller: 'OtherPortfolioCtrl',
      controllerAs: 'otherPortfolioVm'      
    }) 
    .state('portfolio.powerbi', {
      abstract: false,
      url: '/portfolioPowerbi',
      template: require('./portfolioPowerbi/powerbi.html'),
      controller: 'powerbiPortfolioCtrl',
      controllerAs: 'powerbiCtrl'      
    }) 
    .state('portfolio.visitPortfolio', {
      abstract: false,
      url: '/visitPortfolio',
      template: require('./myPortfolio/myPortfolio.html'),
      controller: 'MyPortfolioCtrl',
      controllerAs: 'portfolioVm',
      params: {
        haveGuest      : true,
        isOnEvaluation : false,
        isExternal     : false
      }
    })  
    .state('portfolio.evaluationOfPortfolio', {
      abstract: false,
      url: '/evaluationOfPortfolio',
      template: require('./myPortfolio/myPortfolio.html'),
      controller: 'MyPortfolioCtrl',
      controllerAs: 'portfolioVm',
      params: {
        haveGuest      : true,
        isOnEvaluation : true,
        isExternal     : false
      }
    }) 
    .state('portfolio.listEvaluationPortfolio', {
      abstract: false,
      url: '/listEvaluationPortfolio',
      template: require('./evaluationPortfolio/evaluationPortfolio.html'),
      controller: 'EvaluationPortfolioCtrl',
      controllerAs: 'evaluationVm'      
    }) 
    .state('portfolio.parametrization', {
      abstract: false,
      url: '/portfolioParametrization',
      template: require('./parametrization/portfolioParametrization.html'),
      controller: 'PortfolioParametrizationCtrl',
      controllerAs: 'parametrizationVm'      
    })  

    .state('fullscreenPortfolio', {
      url: '/app/portfolio',
      abstract: false,
      views: {
        '': {
          template: require('../../../layout/layout-fullscreen-portfolio.html')
        },
        'content': {
          template: require('../../../layout/content-fullscreen.html')
        },
        'aside': {
          template: require('../../../layout/aside-fullscreen-portfolio.html'),
          controller: 'AsideCtrl'
        }
      }
    })

    .state('fullscreenPortfolio.externalVisitPortfolio', {
      abstract: false,
      url: '/public?ownerPortfolio=:userId&external',
      template: require('./myPortfolio/myPortfolio.html'),
      controller: 'MyPortfolioCtrl',
      controllerAs: 'portfolioVm',
      params: {
        haveGuest      : true,
        isOnEvaluation : false,
        isExternal     : true
      }
    }) 
}



// WEBPACK FOOTER //
// ./src/app/u-faculty/portfolio/portfolio.route.js